/*
创建者 魏强(2018.1.24)
首页
*/
<template>
  <div
    v-if="show"
    class="main-wrapper-cen"
  >
    <!-- 首页banner广告 -->
    <banner
      :banner-data="homePageAdvertisementDTO.advList"
    >
    </banner>
    <div class="home-warpper">
      <div class="wrapper">
        <!--实惠热卖-->
        <bannerSquare
          :newDailyGoodsList="newDailyGoodsList"
          :enterpriseShopGoodsList="enterpriseShopGoodsList"
          :selfRunGoodsList="selfRunGoodsList"
        >
        </bannerSquare>

        <!--网店商家-->
        <!-- <perference-sale title="网店商家" :showTab="true" :isShowBg="true"></perference-sale> -->
        <!-- 推荐 -->
        <perference-sale title="为您推荐" :showTab="true" :isShowBg="true"></perference-sale>

        <!-- <bannerSquare
          :newDailyGoodsList="newDailyGoodsList"
          :enterpriseShopGoodsList="enterpriseShopGoodsList"
          :selfRunGoodsList="selfRunGoodsList"
        >
        </bannerSquare> -->

      </div>

    </div>
  </div>
</template>
<script>
import {
  getBannerSquare,
  pcIndexHome,
} from "api/home.js";
import { getAddressInfo } from "api/user.js";
import banner from "./home-page/banner";
import buylimit from "./home-page/buy-limit";
import selfsupport from "./home-page/self-support";
import crossBarAd from "./home-page/cross-bar-ad";
import brand from "./home-page/brand";
import homeModule from "./home-page/home-module/index.vue";
import continueShopping from "./home-page/continue-shopping";
import middleAds from "./home-page/middle-ads/index";
import saleZone from "./home-page/sale-zone/index";
import bannerSquare from "./home-page/banner-square/index";
import perferenceSale from "./home-page/perference-sale/index";
// import specialOffers from './home-page/specialOffers/index';

export default {
  components: {
    banner,
    brand,
    buylimit,
    selfsupport,
    homeModule,
    crossBarAd,
    continueShopping,
    middleAds,
    saleZone,
    bannerSquare,
    perferenceSale,
    // specialOffers,
  },
  data() {
    return {
      bkflag: 1, //默认选中第一个
      scrollTopShow: false, //右侧菜单是否显示
      show: false,
      flashNewsList: {},
      homePageAdvertisementDTO: {},
      qyLeftUpAdv: {},
      qyLeftDownAdv: {},
      qyMiddleUpAdv: {},
      qyMiddleMiddleAdv: {},
      qyMiddleDownAdv: {},
      qyRightGoodsAdv: {},
      qyDownAdv: {},
      jpLeftAdv: {},
      jpMiddleDownAdv: {},
      jpMiddleUpAdv: {},
      jpRightGoodsAdv: {},
      jpDownAdv: {},
      pcZyppGoodsAdv: {}, //自营品牌广场

      //频道广场
      basketJrhdList: {}, //节日活动
      ptsqsxList: {}, //拼团
      zyztcpfhProductList: {}, //特价
      jrhdzqProductList: {}, //一村一品
      basketBrandList: {}, //菜篮子
      zyypProductList: {}, //供应链
      xfqfProductList: {}, //消费全返
      // pcZyztcpfhGoodsAdv: {}, //自营主推产品分红专区
      // pcXfqfGoodsAdv: {}, //消费全返专区
      // pcZyypGoodsAdv: {}, //直营优品专区
      // pcZyjjgwGoodsAdv: {}, //自营积分购物专区
      // pcHmdjkGoodsAdv: {}, //惠民大健康专区
      // pcZlyyGoodsAdv: {}, //中联云众专区

      dailyNewGoods: {}, //每日上新
      dailyRankGoods: {}, //热销榜
      selfRunGoodsList: [], // 自营优品
      newDailyGoodsList: [], // 每日上新
      enterpriseShopGoodsList: [], // 企业店铺商品（网店商品）

      pcXrsdGoodsAdv: {}, //新人首单免费专区
      pcGwqjfStoreGoodsAdv: {}, //现金券积分抵扣专区
      limitPurchaseProductList: { list: [] }, //限时特价商品
    };
  },
  created() {
    this.fetchPcHomeData();
    this.fetchBannerSquareData();
    if(localStorage.getItem('townList')) {
      console.log('有集合--');
    } else {
      this.getAddressInfo()
    }

    console.log("欢迎光临开心云商（v3.0.5）");
  },
  mounted() {
    // window.addEventListener("scroll", this.scrollToTop);
    console.log(this.scrollToTop)
  },
  methods: {
    fetchPcHomeData() {
      pcIndexHome().then((json) => {
        if (json.resCode == 1) {
          let data = json.data;
          this.show = !!data;
          //banner 广告
          this.homePageAdvertisementDTO = data.homePageAdvertisementDTO;
          this.flashNewsList = data.gdNews || [];
          this.rightBannerAdvertisementDTO = data.rightBannerAdvertisementDTO;
          //限时特价
          // this.specialOffersCacheDTO = data.specialOffersCacheDTO;
          //企业品牌
          // this.qyLeftUpAdv = data.enterpriseBrandAdvertisementDTO;
          // this.qyLeftDownAdv = data.enterpriseBrandListAdvertisementDTO;
          // this.qyMiddleUpAdv = data.enterpriseBrandCenterAdvertisementDTO;
          // this.qyMiddleMiddleAdv = data.enterpriseBrandMiddleDownAdvertisementDTO;
          // this.qyMiddleDownAdv = data.middleDownFiveAdvertisementDTO;
          // this.qyRightGoodsAdv = data.rightGoodsAdvertisementDTO;
          // this.qyDownAdv = data.enterpriseBrandDownAdvertisementDTO;
          //金牌网店
          // this.jpLeftAdv = data.goldShopAdvertisementDTO;
          // this.jpMiddleDownAdv = data.goldShopMiddleDownAdvertisementDTO;
          // this.jpMiddleUpAdv = data.goldShopMiddleUpAdvertisementDTO;
          // this.jpRightGoodsAdv = data.goldShopDownRightAdvertisementDTO;
          // this.jpDownAdv = data.goldShopDownAdvertisementDTO;
          //热销商品
          // this.rxLeftAdv = data.goodsSellHotCakesAdvertisementDTO;
          // this.rxMiddleUpAdv = data.goodsSellHotCakesUpAdvertisementDTO;
          // this.rxMiddleDownAdv = data.goodsSellHotCakesDownAdvertisementDTO;
          // this.rxRightGoodsAdv = data.goodsSellHotCakesRightAdvertisementDTO;
          // this.rxDownAdv = data.goodsSellHotCakesRightDownAdvertisementDTO;

          this.pcZyppGoodsAdv = data.selfOwnedBrandPlazaAdvertisementDTO;
          // this.pcXrsdGoodsAdv = data.freeAreaNewCoupleFirstSingleAdvertisementDTO;
          // this.pcGwqjfStoreGoodsAdv = data.shoppingVoucherPointsDeductionAreaAdvertisementDTO;
          //频道广场
          this.basketJrhdList = data.newYearCarnivalShoppingAreaAdvertisementDTO;
          this.ptsqsxList = data.groupMoneyWorryZoneAdvertisementDTO;
          this.zyztcpfhProductList = data.zyztcpfhProductList;
          this.jrhdzqProductList = data.oneCountyProductZoneAdvertisementDTO;
          this.basketBrandList = data.basketLivingAreaAdvertisementDTO;
          this.zyypProductList = data.directSupplyChainZoneAdvertisementDTO;
          this.xfqfProductList = data.allReturnZoneAdvertisementDTO;
        } else {
          console.log("首页数据错误");
        }
      });
    },
    fetchBannerSquareData() {
      getBannerSquare().then((res) => {
        if (res.resCode == 1) {
          let {
            selfRunGoodsList,
            newDailyGoodsList,
            goldShopGoodsList,
          } = res.data;
          this.selfRunGoodsList = selfRunGoodsList;
          this.newDailyGoodsList = newDailyGoodsList;
          this.enterpriseShopGoodsList = goldShopGoodsList;
        }
      });
    },
    //返回顶部
    goTop() {
      let top = document.documentElement.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop); //清除定时器
        }
      }, 20);
    },
    // 获取省列表
    getAddressInfo() {
      getAddressInfo().then((resp) => {
        localStorage.setItem('townList', JSON.stringify(resp))
      });
    },
  },
};
</script>

<style src="../assets/css/index_1.css"/>
<style scoped type="text/less" lang="less">
@keyframes short {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.bk-sider-img {
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: url("//images.kxymall.com/baokuanLogo.png") no-repeat;
  background-size: 100%;
  z-index: 9000;
  cursor: pointer;
  width: 200px;
  height: 240px;
  &:hover {
    animation: short 2s infinite;
  }
}
@media (max-width: 1441px) {
  .bk-sider-img {
    position: fixed;
    right: 30px;
    bottom: 100px;
    background: url("//images.kxymall.com/baokuanLogo.png") no-repeat;
    background-size: 100%;
    z-index: 10000;
    cursor: pointer;
    width: 150px;
    height: 180px;
    &:hover {
      animation: short 2s infinite;
    }
  }
}
.main-wrapper-cen {
  width: 100%;
  background: #f3f3f3;
}
.main-wrapper-cen
.home-warpper {
  width: 1226px;
  margin: 0 auto;
  position: relative;
}
.target1 {
  width: 64px;
  height: 0;
  position: fixed;
  top: 120px;
}
.target2 {
  width: 64px;
  height: 0;
  position: absolute;
  top: 120px;
}
.target {
  z-index: 10000;
  font-size: 16px;
  margin-left: 1200px;
  ul {
    width: 44px;
    box-shadow: 0px 1px 4px #bbb;
    background: #fff;
    padding: 4px 6px;
    text-align: center;
  }
  ul li {
    width: 44px;
    line-height: 24px;
    color: #767676;
    text-align: center;
    padding: 4px 0;
    border-bottom: 1px solid #efefef;
    border-width: 80%;
    cursor: pointer;
    .icon {
      display: block;
      width: 0;
      height: 0;
      border-width: 10px 0 10px 10px;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 14px solid #f56a72;
      margin: 0 auto;
    }
  }
  ul li:last-child {
    border-bottom: none;
  }
  .active,
  .fhdb {
    color: #f56a72 !important;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?348d03c4